import _slicedToArray from "/home/jenkins/workspace/web_bgm/bgm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import e from "../../../node_modules/@babel/runtime/helpers/esm/extends.js";
import n, { useState as t, Fragment as i } from "react";
import { Menu as r } from "antd";
import { withRouter as o, NavLink as l } from "react-router-dom";
import * as a from "@ant-design/icons";
var c = r.SubMenu;
var m = o(function (_ref) {
  var o = _ref.theme,
      m = _ref.menus,
      d = _ref.isMobile,
      s = _ref.collapsed,
      p = _ref.location,
      u = _ref.onCollapseChange;

  var _t = t([]),
      _t2 = _slicedToArray(_t, 2),
      h = _t2[0],
      f = _t2[1],
      E = function E(e) {
    return e.map(function (e) {
      return e.children ? n.createElement(c, {
        key: e.id,
        title: n.createElement(i, null, e.icon && n.createElement(a[e.icon], {
          style: {
            marginRight: "4px"
          }
        }), n.createElement("span", null, e.name))
      }, E(e.children)) : n.createElement(r.Item, {
        key: e.id,
        icon: e.icon ? n.createElement(a[e.icon], {
          style: {
            marginRight: "4px"
          }
        }) : null
      }, n.createElement(l, {
        to: e.route || "#"
      }, n.createElement("span", null, e.name)));
    });
  },
      g = function (e) {
    var n = [],
        t = JSON.parse(JSON.stringify(e)),
        i = {};
    return t.forEach(function (e) {
      i[e.id] = e;
    }), t.forEach(function (e) {
      e.pid && i[e.pid] ? (i[e.pid].children || (i[e.pid].children = []), i[e.pid].children.push(e)) : n.push(e);
    }), n;
  }(m),
      y = m.find(function (e) {
    return e.route && e.route === p.pathname;
  }),
      x = y ? function (e) {
    var n = {},
        t = [e];
    m.forEach(function (e) {
      n[e.id] = e;
    });

    var i = function i(e) {
      var r = n[e.id].pid;
      r && (t.push(n[r]), i(n[r]));
    };

    return i(e), t;
  }(y).map(function (e) {
    return e.id;
  }) : [],
      O = s ? {} : {
    openKeys: h
  };

  return n.createElement(r, e({
    mode: "inline",
    theme: o,
    onOpenChange: function onOpenChange(e) {
      var n = m.filter(function (e) {
        return !e.pid;
      }).map(function (e) {
        return e.id;
      }),
          t = e.find(function (n) {
        return -1 === e.indexOf(n);
      });
      var i = e;
      -1 !== n.indexOf(t) && (i = t ? [t] : []), f(i);
    },
    selectedKeys: x,
    onClick: function onClick() {
      d && u(!0);
    }
  }, O), E(g));
});
export default m;